import createAxios from "./axiosHttpMarconi";
import { franquiciaService } from "./franquicia.service";
export const tarifaService = {
  getTarifasByFranquicia,
  getTarifasPaletByFranquicia,
  getAllTarifas,
  getSuplementosCentral,
  getAllTarifasAsExcel,
  getTarifasByFranquiciaId,
  getTarifasById,
  nuevoIncremento,
  finalizarTarifas,
  eliminarTarifas,
  getTarifasMaestros,
  editNombreTarifa,
  getTarifaMaestroById,
};

function getTarifasByFranquicia() {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/tarifa?sort=codigo&order=ascending`;
  return axios.get(urlPath);
}

function eliminarTarifas(body) {
  const axios = createAxios();
  const idFranquicia = JSON.parse(localStorage.getItem("franquicia"));
  let urlPath = `franquicia/${idFranquicia._id}/tarifas_precios`;
  return axios.post(urlPath, body);
}

function finalizarTarifas(body) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/tarifa_precios/finalizar`;
  return axios.put(urlPath, body);
}

function getTarifasById(id) {
  const axios = createAxios();
  const franquicia = JSON.parse(localStorage.getItem("franquicia"));
  let urlPath = `franquicia/${franquicia._id}/tarifa_precio/${id}`;
  return axios.get(urlPath);
}

function getTarifasByFranquiciaId(codigo) {
  const axios = createAxios();
  const franquicia = JSON.parse(localStorage.getItem("franquicia"));
  let urlPath = `franquicia/${franquicia._id}/tarifa`;
  if (codigo && codigo != "") {
    urlPath += `?codigo=${codigo}`;
  }
  return axios.get(urlPath);
}
function getTarifasPaletByFranquicia() {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/tarifa-palets?sort=codigo&order=ascending`;
  return axios.get(urlPath);
}

function getTarifasMaestros(pagination, filters) {
  const axios = createAxios();
  const franquicia = JSON.parse(localStorage.getItem("franquicia"));
  let urlPath = `franquicia/${franquicia._id}/tarifas`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0&limit=10";
  }

  /* if (filters.codigo && filters.codigo != "") {
    urlPath += `&codigo=${filters.codigo}`;
  }

  if (filters.nombre && filters.nombre != "") {
    urlPath += `&nombre=${filters.nombre}`;
  } */
  return axios.get(urlPath);
}

function getTarifaMaestroById(idTarifa) {
  const axios = createAxios();
  const franquicia = JSON.parse(localStorage.getItem("franquicia"));
  let urlPath = `franquicia/${franquicia._id}/tarifas/${idTarifa}`;
  return axios.get(urlPath);
}

function editNombreTarifa(idTarifa, body) {
  const axios = createAxios();
  const franquicia = JSON.parse(localStorage.getItem("franquicia"));
  let urlPath = `franquicia/${franquicia._id}/tarifas/${idTarifa}`;
  return axios.put(urlPath, body);
}

function getSuplementosCentral() {
  const axios = createAxios();
  let urlPath = "/conceptos";
  return axios.get(urlPath);
}

function getAllTarifas(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquicia/${user.extraData.franquiciaId}/tarifas_precios`;
  if (pagination) {
    urlPath += `?sort=desde&order=ascending&page=${
      pagination.currentPage - 1
    }&limit=${pagination.perPage}`;
  } else {
    urlPath += "?page=0&limit=10";
  }
  urlPath += getFilters(filters);
  return axios.get(urlPath);
}

function getAllTarifasAsExcel(filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquicia/${user.extraData.franquiciaId}/tarifa_precios/excel?limit=2000`;
  urlPath += getFilters(filters);
  urlPath += "&sort=desde&order=descending";
  return axios.get(urlPath, {
    responseType: "blob",
  });
}

function getFilters(filters) {
  let urlPath = "";
  if (filters && filters.date) {
    urlPath += `&desde=${filters.date[0]}`;
    urlPath += `&hasta=${filters.date[1]}`;
  }
  if (filters && filters.tipo) {
    urlPath += `&tipo=${filters.tipo}`;
  }
  if (filters && filters.codigoTarifa) {
    urlPath += `&codigo=${filters.codigoTarifa}`;
  }
  if (filters && filters.descripcion) {
    urlPath += `&descripcion=${filters.descripcion}`;
  }
  if (filters && filters.servicio) {
    urlPath += `&servicio=${filters.servicio}`;
  }
  if (filters && filters.geografico) {
    urlPath += `&geografico=${filters.geografico}`;
  }
  urlPath += `&vigente=${filters.vigente}`;
  return urlPath;
}

function nuevoIncremento(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquicia/${user.extraData.franquiciaId}/tarifa_precios/incremento`;
  return axios.post(urlPath, request);
}
